import React from 'react';

import { Distance } from '../../api/api';
import { useCategoryState } from '../category/category-state';
import { useTranslations } from '../commons/utils/translations/translate';

interface DistanceComponentProps {
  distance?: Distance;
  showTimeOnly?: boolean;
}

export const DistanceComponent: React.FC<DistanceComponentProps> = ({ distance, showTimeOnly }) => {
  const { tICU } = useTranslations();
  const category = useCategoryState();

  const formatTime = (time: number, transport: string) => {
    const hours = Math.floor(time / 60);
    const minutes = time % 60;
    return (
      (hours > 0 ? tICU('widget.delivery_time.modal.HOURS', { hour: hours }) : '') +
      ' ' +
      (minutes > 0 ? tICU('widget.delivery_time.modal.MINUTES', { minute: minutes }) : '') +
      ' ' +
      tICU(`widget.TRANSPORT_BY_${transport.toUpperCase()}`)
    );
  };

  if (!distance) {
    return null;
  }

  const showDistance = category.flags.enable_additional_location_info && !showTimeOnly;

  return (
    <>
      <span>{formatTime(distance.minutes, distance.type)}</span>
      {showDistance && <span>{getFormatedDistance(distance.meter)}</span>}
    </>
  );
};

const getFormatedDistance = (distance: number) =>
  `${distance > 999 ? (distance / 1000).toFixed(2) : distance}${distance > 999 ? 'km' : 'm'}`;
